import React, { useState, useEffect } from 'react';
import FloatingBanner, { BannerActionButton } from '../common/FloatingBanner';

interface RefreshBannerProps {
  onRefresh: () => void;
  onIgnore: () => void;
}

// Geometry and button styling live in the shared FloatingBanner (HITL-1499);
// this component keeps only what is its own — the 5s re-arm that stops a double
// tap from firing both actions. No accent rule and no icon, so the look is
// unchanged.
const RefreshBanner = ({ onRefresh, onIgnore }: RefreshBannerProps) => {
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (isDisabled) {
      timer = setTimeout(() => {
        setIsDisabled(false);
      }, 5000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isDisabled]);

  const handleRefresh = () => {
    if (!isDisabled) {
      setIsDisabled(true);
      onRefresh();
    }
  };

  const handleIgnore = () => {
    if (!isDisabled) {
      setIsDisabled(true);
      onIgnore();
    }
  };

  return (
    <FloatingBanner
      actions={
        <>
          <BannerActionButton onClick={handleRefresh} disabled={isDisabled}>
            Refresh
          </BannerActionButton>
          <BannerActionButton
            variant="danger"
            onClick={handleIgnore}
            disabled={isDisabled}
          >
            Ignore
          </BannerActionButton>
        </>
      }
    >
      <span>🚀 A new HITL version is available</span>
    </FloatingBanner>
  );
};

export default RefreshBanner;
